import { __generator, __spreadArray } from "tslib";
import { all, put, call, select, takeEvery } from 'redux-saga/effects';
import { withOffset, selectors } from '../../Stream';
import { setWatchingState } from '../../WatchButton/redux/actionCreators';
import { fetchNext } from './actionCreators';
import { request } from '../../xhr';
function handleFetchNext(action) {
    var streamId, _a, offset, limit, streamParams, params, result, total, hasMore, nextOffset, results;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                streamId = action.payload.streamId;
                return [4 /*yield*/, select(function (state) { return ({
                        streamParams: selectors.getStreamParams(state, streamId),
                        offset: withOffset.selectors.getNextOffset(state, streamId),
                        limit: selectors.getItemsPerFetch(state, streamId),
                    }); })];
            case 1:
                _a = _b.sent(), offset = _a.offset, limit = _a.limit, streamParams = _a.streamParams;
                params = {
                    deviationid: streamParams.deviationId,
                    type: 'favourite',
                    offset: offset,
                    limit: limit,
                    expand: 'user.profile',
                };
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'deviation/who',
                        params: params,
                    })];
            case 2:
                result = _b.sent();
                if (!result) return [3 /*break*/, 4];
                total = result.total, hasMore = result.hasMore, nextOffset = result.nextOffset, results = result.results;
                return [4 /*yield*/, all(__spreadArray(__spreadArray([], results.map(function (user) { var _a; return put(setWatchingState(user.username, (_a = user.isWatching) !== null && _a !== void 0 ? _a : false)); }), true), [
                        put(withOffset.actions.fetchSuccessDeduped({
                            streamId: streamId,
                            hasMore: !!hasMore,
                            nextOffset: nextOffset !== null && nextOffset !== void 0 ? nextOffset : undefined,
                            items: results,
                            total: total,
                        })),
                    ], false))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
export default function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([takeEvery(fetchNext, handleFetchNext)])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map